import { z } from "zod";

const APP_STORE_URL =
  "https://apps.apple.com/us/app/saile-medical/id6738873421";
const appStorePageIdSchema = z.string().uuid();

export function getProviderAppStoreUrl({
  jobPostsEnabled,
  internalPageId,
}: {
  jobPostsEnabled?: boolean;
  internalPageId?: string;
}): string | null {
  if (jobPostsEnabled === true) {
    return APP_STORE_URL;
  }

  // A missing or malformed custom-page ID must not send internal providers
  // to the public marketplace listing. They can keep using the web app.
  const pageId = appStorePageIdSchema.safeParse(internalPageId?.trim());
  if (!pageId.success) {
    return null;
  }

  const url = new URL(APP_STORE_URL);
  url.searchParams.set("ppid", pageId.data);
  return url.toString();
}
